export const FETCH_ORDER_REQUEST = 'FETCH_ORDER_REQUEST';
export const FETCH_ORDER_SUCCEEDED = 'FETCH_ORDER_SUCCEEDED';
export const FETCH_ORDER_FAILED = 'FETCH_ORDER_FAILED';
